/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_CertificatesInputs */

const en_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificates`)
};

const de_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zertifikate`)
};

const fr_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificats`)
};

const es_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificados`)
};

const it_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificati`)
};

const nl_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificaten`)
};

const pl_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certyfikaty`)
};

const fi_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todistukset`)
};

const da_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certifikater`)
};

const sv_resume_editor_certificates = /** @type {(inputs: Resume_Editor_CertificatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certifikat`)
};

/**
* | output |
* | --- |
* | "Certificates" |
*
* @param {Resume_Editor_CertificatesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_certificates = /** @type {((inputs?: Resume_Editor_CertificatesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_CertificatesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_certificates(inputs)
	if (locale === "fr") return fr_resume_editor_certificates(inputs)
	if (locale === "es") return es_resume_editor_certificates(inputs)
	if (locale === "it") return it_resume_editor_certificates(inputs)
	if (locale === "nl") return nl_resume_editor_certificates(inputs)
	if (locale === "pl") return pl_resume_editor_certificates(inputs)
	if (locale === "fi") return fi_resume_editor_certificates(inputs)
	if (locale === "da") return da_resume_editor_certificates(inputs)
	if (locale === "sv") return sv_resume_editor_certificates(inputs)
	return en_resume_editor_certificates(inputs)
});